<template>
  <b-menu class="is-custom-mobile MenuRecursive">
    <MenuRecursiveHelper
        :items="items"
        @input="input"
        :value="String(value)"
        :allLevelsConfig="allLevelsConfig"
        :currentNestingDepth="0"
    />
  </b-menu>
</template>

<script>
import MenuRecursiveHelper from "@/components/global/MenuRecursiveHelper.vue"
export default {
  name: "MenuRecursive",
  components: {
    MenuRecursiveHelper
  },
  data() {
    return {
    };
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    },
    allLevelsConfig: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: String,
      default() {
        return ""
      }
    }
  },
  methods:{
    input(path){
      this.$emit("input", path)
    },
  }
};
</script>
<style lang="scss">
.MenuRecursive {
  .is-active svg {
    &:not(.is-outline-icon) {
      filter: invert(29%) sepia(94%) saturate(693%) hue-rotate(157deg) brightness(100%) contrast(102%);
    }
  }
  .is-expanded svg {
    &:not(.is-outline-icon) {
      filter: invert(29%) sepia(94%) saturate(693%) hue-rotate(157deg) brightness(100%) contrast(102%);
    }
  }
  .icon-text svg {
    &:not(.is-outline-icon) {
      stroke-width: 0px;
    }
  }
}
</style>
